import { RecipeBreakdown } from '@/models/Recipes/RecipeBreakdown';
import Repository from './Repository';
import { MethodResult } from './ResultTypes/MethodResult';
import { AxiosResponse } from 'axios';
import { SingleNutrientReportDto } from '@/models/Recipes/SingleNutrientReportDto';
import {ListResult} from "@/utils/API/ResultTypes/ListResult";
import { ProteinQualityRowDto } from '@/models/Recipes/ProteinQualityRowDto';


const resource = '/recipe/reports';

export default {
  getRecipeCalculationBreakdown(model: any) {
    return Repository.post<{ country: number, recipeId: number }, AxiosResponse<MethodResult<RecipeBreakdown>>>(
      `${resource}/GetRecipeCalculationBreakdown`,
      model,
      { withCredentials: true }
    );
  },
  getSingleNutrientReport(recipeId: number) {
    return Repository.get<MethodResult<SingleNutrientReportDto>>(
      `${resource}/GetSingleNutrientReport?recipeId=${recipeId}`,
      { withCredentials: true }
    );
  },
  getProteinQualityBreakDown(recipeId: number) {
    return Repository.get<ListResult<ProteinQualityRowDto>>(
      `${resource}/GetProteinQualityReport?recipeId=${recipeId}`,
      { withCredentials: true }
    );
  }
};
